import PeriodicalReportTable from './PeriodicalReportTable';

export default PeriodicalReportTable;
